import { createAction, props, union } from '@ngrx/store';

import { ChangeTypeEnum } from '@global/infrastructure/enums/change-type.enum';

import { GwDate } from '@global/infrastructure/interfaces/app-dates';
import { KeyValueDict } from '@global/infrastructure/interfaces/key-value-dict';


export const loadVerifyPolicy = createAction(
  '[LoadPolicy] Load  Verify Policy',
  props<{ token?: string }>()
);
export const loadPolicy = createAction(
  '[LoadPolicy] Load Policy',
  props<{ policyNumber: string }>()
);

export const loadPolicyVerifySucceeded = createAction(
  '[LoadPolicy] Load Policy Verify Succeeded',
  props<{ data: any }>()
);
export const loadPolicySucceeded = createAction(
  '[LoadPolicy] Load Policy Succeeded',
  props<{ data: any }>()
);

export const loadPolicyEffectiveDate = createAction(
  '[LoadPolicy] Load Policy Effective Date found',
  props<{ effectiveDate: any }>()
);

export const loadPolicyFailed = createAction(
  '[LoadPolicy] Load Policy Failed',
  props<{ error: any }>()
);

export const billing = createAction(
  '[LoadPolicy] Billing',
  props<{ token: string, changeType: string }>()
);

export const billingSucceeded = createAction(
  '[LoadPolicy] Billing Succeeded',
  props<{ data: any, changeType: string }>()
);

export const billingFailed = createAction(
  '[LoadPolicy] Billing Failed',
  props<{ error: any }>()
);

export const retrieveQuote = createAction(
  '[LoadPolicy] Retrieve Policy',
  props<{ token: string }>()
);

export const retrieveQuoteSucceeded = createAction(
  '[LoadPolicy] Retrieve Policy Succeeded',
  props<{ data: any }>()
);

export const retrieveQuoteFailed = createAction(
  '[LoadPolicy] Retrieve Policy Failed',
  props<{ error: any }>()
);

export const resetLoadPolicyError = createAction(
  '[LoadPolicy] Reset Load Policy Error'
);

export const resetPayloadChanges = createAction(
  '[Policy] Reset Payload Changes'
);

export const resetDriversInPayloadChanges = createAction(
  '[Policy] Reset Drivers In Payload Changes'
);

export const updatePayloadChanges = createAction(
  '[Policy] Update Payload Changes',
  props<{ data: KeyValueDict<any> }>()
);

export const updateDriver = createAction(
  '[Policy] Update Driver',
  props<{ data: any }>()
);

export const updateChangeTypeAndEffectiveDatesOfRequestPayload = createAction(
  '[Policy] Update Change Type And Effective Dates Of Request Payload',
  props<{ changeType: ChangeTypeEnum, effectiveDate: GwDate, expirationDate_dlg?: GwDate, isQuoteRetrieved: boolean }>()
);

export const replaceRequestPayloadWithNewQuote = createAction(
  '[Policy] Replace Request Payload With NewQuote',
  props<{ premResult: any }>()
);

export const updateNewTemporaryDriversOfRequestPayload = createAction(
  '[Policy] Update New Temp Drivers Of Request Payload',
  props<{ newDrivers: any[] }>()
);

export const updateBoundPolicy = createAction(
  '[Policy] Update Bound Policy',
  props<{ boundPolicy: any }>()
);

export const updateCreditCardDetailsOfRequestPayload = createAction(
  '[Policy] Update Credit Card Details Of Request Payload',
  props<{ creditCardDetails_dlg: any }>()
);

export const updateDirectDebitDetailsOfRequestPayload = createAction(
  '[Policy] Update Direct Debit Details Of Request Payload',
  props<{ data: any }>()
);

export const updatePaymentDatePayload = createAction(
  '[Policy] Update payment date of Request Payload',
  props<{ paymentDate: number }>()
);

export const updateGatewayTimeoutError = createAction(
  '[Policy] Update Policy State Errors'
);

export const updateInvalidPromoCodeError = createAction(
  '[Policy] Update Invalid PromoCode Error'
);

export const resetPolicyStateErrors = createAction(
  '[Policy] Reset Policy State Errors'
);

export const redirectToOutsideValidDurationHardStop = createAction(
  '[Policy] Redirect To Outside Valid Duration Hard Stop',
  props<{ effectiveDate: Date, earliestNextStartDate: Date, previousChangeType: ChangeTypeEnum }>()
);

export const redirectToSuspendedVehicleHardStop = createAction(
  '[Policy] Redirect To Suspended Vehicle Hard Stop'
);

export const removeTempBlock = createAction(
  '[Policy] Remove Temp Block'
);

export const updateRequestPayloadError = createAction(
  '[Policy] Update Request Payload Error',
  props<{ error: any }>()
);

export const updateNewDirectDebitRequirement = createAction(
  '[Policy] Update New Direct Debit Requirement'
);

const all = union({
  loadPolicy,
  loadPolicyVerifySucceeded,
  loadPolicySucceeded,
  loadPolicyEffectiveDate,
  loadPolicyFailed,
  billing,
  billingSucceeded,
  billingFailed,
  resetLoadPolicyError,
  resetPayloadChanges,
  resetDriversInPayloadChanges,
  updatePayloadChanges,
  updateNewTemporaryDriversOfRequestPayload,
  replaceRequestPayloadWithNewQuote,
  updateBoundPolicy,
  updateChangeTypeAndEffectiveDatesOfRequestPayload,
  updateCreditCardDetailsOfRequestPayload,
  updateDirectDebitDetailsOfRequestPayload,
  updatePaymentDatePayload,
  updateGatewayTimeoutError,
  updateInvalidPromoCodeError,
  resetPolicyStateErrors,
  redirectToOutsideValidDurationHardStop,
  redirectToSuspendedVehicleHardStop,
  retrieveQuote,
  retrieveQuoteSucceeded,
  retrieveQuoteFailed,
  removeTempBlock,
  updateRequestPayloadError,
  updateNewDirectDebitRequirement,
  updateDriver
});

export type PolicyActionsUnion = typeof all;
